'use strict';
document.documentElement.classList.add('js');
const menu = document.querySelector('.menu-button');
const navigation = document.querySelector('#navigation');
const mobile = matchMedia('(max-width: 799px)');
const purpose = document.querySelector('#kd-purpose');
const requestedPurpose = new URLSearchParams(location.search).get('purpose');
if (purpose && [...purpose.options].some(option => option.value === requestedPurpose)) purpose.value = requestedPurpose;
function setMenu(open) {
  navigation.dataset.open = String(open);
  menu.setAttribute('aria-expanded', String(open));
}
function resizeMenu() {
  menu.hidden = !mobile.matches;
  setMenu(!mobile.matches);
}
resizeMenu();
mobile.addEventListener('change', resizeMenu);
menu.addEventListener('click', () => setMenu(menu.getAttribute('aria-expanded') !== 'true'));
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && mobile.matches && menu.getAttribute('aria-expanded') === 'true') {
    setMenu(false);
    menu.focus();
  }
});
